import type { TFunction } from 'i18next';

export function getLocalizedFrameworkArgLabel(t: TFunction, argName: string): string {
  // Key shape: framework.args.<raw framework arg name>
  return t(`framework.args.${argName}`, argName);
}

export function getLocalizedFrameworkUnit(t: TFunction, unit: string): string {
  const u = unit.trim();
  if (!u) return '';
  // Key shape: framework.units.<raw framework unit string>
  // Examples: framework.units.m/s, framework.units.cm, framework.units.degrees
  return t(`framework.units.${u}`, u);
}
